import React from 'react'

const EmptyState = ({ icon, title, text, actionLabel, onAction }) => (
    <div className='mv-empty'>
        {icon && <div className='mv-empty-icon' aria-hidden='true'>{icon}</div>}
        <h2 className='mv-empty-title'>{title}</h2>
        {text && <p className='mv-empty-text'>{text}</p>}
        {actionLabel && onAction && (
            <button type='button' className='mv-btn mv-btn-primary' onClick={onAction}>{actionLabel}</button>
        )}
    </div>
)

export default EmptyState
